<template>
  <div class="meu-plano">
    <b-card>
      <b-card-header>
        <b-card-title>Meu Plano</b-card-title>
      </b-card-header>
      <b-card-body>
        <p class="text-muted">
          Informações sobre seu plano atual.
        </p>
        <!-- Conteúdo do plano será implementado aqui -->
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody,
} from 'bootstrap-vue'

export default {
  name: 'MeuPlano',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
  },
}
</script>
